"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalService = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ReactDOM = __importStar(require("react-dom"));
var mobx_1 = require("mobx");
var Modal_model_1 = require("./Modal_model");
var Modal_view_1 = require("./Modal_view");
var IUiAction_1 = require("../uiAction/IUiAction");
var Button_1 = require("../ui/Button");
var ModalService = /** @class */ (function () {
    function ModalService(el, shouldUserRenderDom) {
        if (shouldUserRenderDom === void 0) { shouldUserRenderDom = true; }
        var _this = this;
        this.stack = [];
        this.setTitle = function (title) {
            _this.model.title = title;
            _this.currentConfig.title = title;
        };
        this.hideAll = function () {
            while (_this.currentConfig) {
                _this.currentConfig = _this.stack.pop();
            }
            _this.hideModalElement();
        };
        /**
         * Hides the modal wrapper that is injected to
         * 'body' in the init function
         */
        this.hideModalElement = function () {
            _this.model.animateOutFn();
            setTimeout(function () {
                _this.model.visible = false;
                _this.model.content = null;
                if (_this.modalWrapper) {
                    _this.modalWrapper.style.display = "none";
                }
            }, 500);
        };
        /**
         * Shows the modal wrapper that is injected to
         * 'body' in the init function
         */
        this.showModalElement = function () {
            _this.model.animateInFn();
            setTimeout(function () {
                if (_this.modalWrapper) {
                    _this.modalWrapper.style.display = "block";
                }
            });
        };
        this.renderComponent = function () {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "modal__service-wrapper--inner", style: { display: "none" }, ref: function (e) { return (_this.modalWrapper = e); } }, { children: (0, jsx_runtime_1.jsx)(Modal_view_1.ModalView, { model: _this.model }) })));
        };
        this.model = new Modal_model_1.ModalModel(this);
        if (shouldUserRenderDom) {
            this.init(el);
        }
    }
    ModalService.prototype.show = function (config) {
        this.currentConfig = config;
        this.model.set(config);
        this.showModalElement();
    };
    ModalService.prototype.showAsync = function (cb) {
        var _this = this;
        return new Promise(function (res, rej) {
            _this.showModalElement();
            _this.currentConfig = cb(res, rej, _this.model);
            _this.model.set(_this.currentConfig, res, rej);
        });
    };
    ModalService.prototype.showConfirmDialog = function (title, content, yes, no, componentProps, onPositive, onNegative, yesBtnType //"link-big"
    ) {
        var _this = this;
        if (yes === void 0) { yes = "yes"; }
        if (no === void 0) { no = "no"; }
        return new Promise(function (res, rej) {
            _this.showWithReturn({
                title: title,
                content: content,
                showClose: false,
                componentProps: componentProps,
                animationOptions: {
                    animateIn: "fadeIn",
                    animateOut: "fadeOut",
                    speed: 5
                },
                actions: [
                    {
                        id: "yes",
                        label: yes,
                        onAction: function () {
                            onPositive ? onPositive() : _this.hide();
                            res(true);
                        },
                        rendersIn: IUiAction_1.UiActionRenderers.BUTTON,
                        componentProps: {
                            type: yesBtnType || Button_1.ButtonTypes.PRIMARY,
                            className: "float-right ml-2"
                        }
                    },
                    {
                        id: "no",
                        label: no,
                        onAction: function () {
                            onNegative ? onNegative() : _this.hide();
                            res(false);
                        },
                        rendersIn: IUiAction_1.UiActionRenderers.BUTTON,
                        componentProps: {
                            type: Button_1.ButtonTypes.LINK,
                            className: "float-right ml-2"
                        }
                    }
                ]
            });
        });
    };
    ModalService.prototype.showWithReturn = function (config) {
        if (this.currentConfig) {
            this.stack.push(this.currentConfig);
        }
        this.show(config);
    };
    ModalService.prototype.setActions = function (actions) {
        this.model.actions = actions;
    };
    ModalService.prototype.setContent = function (content) {
        this.model.content = content;
        this.currentConfig.content = content;
    };
    ModalService.prototype.isVisible = function () {
        return this.model.visible;
    };
    ModalService.prototype.hide = function () {
        this.currentConfig = this.stack.pop();
        if (this.currentConfig) {
            this.show(this.currentConfig);
        }
        else {
            this.hideModalElement();
        }
    };
    ModalService.prototype.init = function (el) {
        var child = document.createElement("div");
        child.className = "modal__service-wrapper";
        child.id = "ModalWrapperService";
        this.modalWrapper = child;
        this.hideModalElement();
        if (!el) {
            el = child;
            document.querySelector("body").appendChild(el);
            this.modalWrapper = el;
            ReactDOM.render((0, jsx_runtime_1.jsx)(Modal_view_1.ModalView, { model: this.model }), el);
        }
    };
    __decorate([
        mobx_1.action.bound
    ], ModalService.prototype, "show", null);
    __decorate([
        mobx_1.action.bound
    ], ModalService.prototype, "setTitle", void 0);
    __decorate([
        mobx_1.action.bound
    ], ModalService.prototype, "setContent", null);
    __decorate([
        mobx_1.action.bound
    ], ModalService.prototype, "hide", null);
    __decorate([
        mobx_1.action
    ], ModalService.prototype, "hideAll", void 0);
    return ModalService;
}());
exports.ModalService = ModalService;
